import { atom } from 'recoil';

import { FilterModalTypes } from '../../components/FilterModal';
import { OrderByModalTypes } from '../../components/OrderByModal';

export const assetsFiltersAtom = atom<FilterModalTypes.FilterAtom>({
  key: 'assetsDetails/filterSelections',
  default: {
    availableFilters: [],
    selectedFilters: [],
    appliedFilters: [],
  },
});

export const assetsOrderByAtom = atom<OrderByModalTypes.OrderByAtom>({
  key: 'assetsDetails/OrderBySelections',
  default: {
    availableOrderBy: [],
    selectedOrderBy: undefined,
    appliedOrderBy: undefined,
  },
});

export const productsFiltersAtom = atom<FilterModalTypes.FilterAtom>({
  key: 'productsDetails/filterSelections',
  default: {
    availableFilters: [],
    selectedFilters: [],
    appliedFilters: [],
  },
});

export const productsOrderByAtom = atom<OrderByModalTypes.OrderByAtom>({
  key: 'productsDetails/OrderBySelections',
  default: {
    availableOrderBy: [],
    selectedOrderBy: undefined,
    appliedOrderBy: undefined,
  },
});
